import React from 'react';
import { PiButton } from '@sensei/pi-component';
import { Alert, AlertColor, IconButton, Snackbar } from '@mui/material';
import { Close } from '@mui/icons-material';
import useDismissibleSnackbarStyles from '../../styles/snackbar/snackbar.style';

interface ToastMessageProps {
    children: React.ReactNode;
    severity?: AlertColor;
    open: boolean;
    onClose: () => void;
    callback?: () => void;
    fullWidth?: boolean;
}

export default function ToastMessage(props: ToastMessageProps) {
    const classes = useDismissibleSnackbarStyles();
    const isError = props.severity === 'error';

    const getWidth = () => {
        return props?.fullWidth ? classes.fullWidth : classes.contentWidth;
    };
    return (
        <Snackbar
            classes={{ root: classes.root + ' ' + getWidth() }}
            open={props.open}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
        >
            <Alert
                icon={false}
                variant="filled"
                classes={{
                    root: classes.alertRoot,
                    message:
                        classes.message +
                        ' ' +
                        (isError ? classes.errorMessage : classes.alertMessage),
                    action: classes.alertAction,
                }}
                severity={props.severity}
                action={
                    <>
                        {props.callback && isError && (
                            <PiButton
                                color="secondary"
                                className={classes.retry}
                                onClick={props.callback}
                            >
                                TRY AGAIN
                            </PiButton>
                        )}
                        <IconButton
                            className={classes.iconButton}
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={props.onClose}
                        >
                            <Close fontSize="inherit" />
                        </IconButton>
                    </>
                }
            >
                {props.children}
            </Alert>
        </Snackbar>
    );
}
